module.exports = __webpack_public_path__ + "static/img/coreProducta.99ec433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/coreProducta.png
// module id = 1roF
// module chunks = 1